import type { ComponentProps } from 'react';

import VerificationInformation from '@/features/verification/components/information';
import VerificationLayout from '@/features/verification/layout';

interface VerificationInformationPageProps extends ComponentProps<typeof VerificationInformation> {
  layoutProps?: ComponentProps<typeof VerificationLayout>;
}

const VerificationInformationPage = ({ layoutProps, ...props }: VerificationInformationPageProps) => {
  return (
    <VerificationLayout {...layoutProps}>
      <VerificationInformation {...props} />
    </VerificationLayout>
  );
};
VerificationInformationPage.displayName = 'VerificationInformationPage';

export default VerificationInformationPage;
